import React from 'react';
import { fm } from '../../utils';
import { Trophy, Medal } from 'lucide-react';

const WaiterStats = ({ data = [] }) => (
  <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
    <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">Garson Performans</h4>
    {data.length === 0 ? (
      <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
    ) : (
      <div className="space-y-2">
        {data.map((w, i) => (
          <div key={w.garsonID || i} className="flex items-center gap-3 p-2 rounded-xl hover:bg-surface-50 dark:hover:bg-surface-700/30 transition-colors">
            <div className="flex-shrink-0">
              {i === 0 ? <Trophy size={18} className="text-amber-400" /> : i === 1 ? <Medal size={18} className="text-surface-400" /> : i === 2 ? <Medal size={18} className="text-amber-600" /> : <div className="w-[18px] text-[10px] font-bold text-surface-400 text-center">{i + 1}</div>}
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <p className="text-xs font-semibold text-surface-800 dark:text-white">{w.garsonAdi}</p>
                <p className="text-xs font-bold text-emerald-600 dark:text-emerald-400">{fm(w.toplamCiro)}</p>
              </div>
              <div className="flex items-center gap-3 mt-0.5">
                <span className="text-[10px] text-surface-400">{w.siparisSayisi} sipariş</span>
                <span className="text-[10px] text-surface-400">Ort: {fm(w.ortalama)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

const rankMedal = (i) =>
  i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : null;

const TableAnalysis = ({ data = [] }) => {
  return (
    <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
      <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">En Yoğun Masalar (Top 10)</h4>
      {data.length === 0 ? (
        <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
      ) : (
        <div className="space-y-1.5">
          {data.map((m, i) => (
            <div key={i} className="flex items-center justify-between p-2 rounded-xl hover:bg-surface-50 dark:hover:bg-surface-700/30 transition-colors">
              <div className="flex items-center gap-2.5">
                <div className="w-7 text-center text-sm flex-shrink-0">
                  {rankMedal(i) || <span className="text-[10px] font-bold text-surface-400">{i + 1}</span>}
                </div>
                <span className="w-7 h-7 rounded-lg bg-surface-100 dark:bg-surface-700 flex items-center justify-center text-[10px] font-bold text-surface-600 dark:text-surface-400">{m.masaNumarasi}</span>
                <div>
                  <p className="text-xs font-semibold text-surface-800 dark:text-white">{m.konum || 'Masa'}</p>
                  <p className="text-[10px] text-surface-400">{m.oturumSayisi} oturum · {fm(m.toplamCiro)}</p>
                </div>
              </div>
              <div className="flex items-center gap-1">
                <div className="text-right">
                  <p className="text-xs font-bold text-emerald-600 dark:text-emerald-400">{fm(m.toplamCiro)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const Heatmap = ({ data = [] }) => {
  const maxAdet = Math.max(...data.map(d => d.adet || 0), 1);
  return (
    <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
      <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">Saatlik Yoğunluk Haritası</h4>
      {data.length === 0 ? (
        <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
      ) : (
        <div className="space-y-2">
          {data.map((d, i) => {
            const intensity = d.adet > 0 ? Math.min(100, (d.adet / maxAdet) * 100) : 0;
            const intensityClass = intensity > 75 ? 'bg-emerald-500' : intensity > 50 ? 'bg-emerald-400' : intensity > 25 ? 'bg-emerald-300' : 'bg-surface-100 dark:bg-surface-700';
            const label = d.saat !== undefined ? `${String(d.saat).padStart(2, '0')}:00` : d.label || '';
            return (
              <div key={i} className="flex items-center gap-3">
                <span className="w-12 text-[10px] text-surface-400 text-right flex-shrink-0">{label}</span>
                <div className="flex-1 flex items-center gap-2">
                  <div className={`h-7 flex-1 rounded-lg ${intensityClass} transition-all duration-500`} style={{ opacity: 0.3 + (intensity / 100) * 0.7 }}>
                    <div className="h-full rounded-lg bg-gradient-to-r from-surface-900/5 to-transparent" style={{ width: `${intensity}%` }} />
                  </div>
                </div>
                <div className="w-28 text-right">
                  <span className="text-[10px] font-semibold text-surface-600 dark:text-surface-400">{d.adet} sipariş</span>
                  <span className="text-[10px] text-surface-400 ml-1">{fm(d.tutar)}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export { WaiterStats, TableAnalysis, Heatmap };
